import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import CellGroup from './CellGroup';
import Heartbeat from './Heartbeat';
import styles from './index.module.scss';

import { Row } from '@/components/ui/dashboard/Monitor';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import { FC_STATUS } from '@/define/robotStatus';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const cx = classNames.bind(styles);

const Monitor = ({ robotId }) => {
  const heartbeat = useRobotTelemetry(robotId, MESSAGE.HEARTBEAT);
  const globalPosition = useRobotTelemetry(robotId, MESSAGE.GLOBAL_POSITION_INT);

  // Arm State, FC Status
  const { isArm, armState, fcStatus } = useMemo(() => {
    const isArm = heartbeat?.isArm ?? false;

    return {
      isArm,
      armState: isArm ? 'ARM' : 'DISARM',
      fcStatus: FC_STATUS[heartbeat?.status] ?? '-',
    };
  }, [heartbeat]);

  // Current Position
  const { lat, lng } = useMemo(() => {
    return {
      lat: globalPosition?.lat ?? 0,
      lng: globalPosition?.lng ?? 0,
    };
  }, [globalPosition]);

  return (
    <div className={cx('container')}>
      <div className={cx('rows')}>
        <Row label="Heartbeat">
          <Heartbeat data={robotId} />
        </Row>
        <Row label="Arm State" value={armState} valueStyle={!isArm && { color: 'red' }} />
        <Row label="FC Status" value={fcStatus} />
        <Row label="Current Position" value={`${lat.toFixed(6)}, ${lng.toFixed(6)}`} />
      </div>
      <CellGroup robotId={robotId} />
    </div>
  );
};

export default Monitor;
